import { postFinishCapture } from 'components/shared/XpressId/services';
import { getErrorFromFinishResponse } from './responses/getErrorFromFinishResponse';

export const finishCapture = async ({ onComplete, onError }) => {
    const { ok } = await postFinishCapture();
    const error = getErrorFromFinishResponse({ ok });
    if (error) return onError(error);

    return onComplete();
};
